import status from '../constants/actionStatus'

export default (state = {
    status : status.PENDING,
    overAllPerformance: {},
}, action = {}) => {

    if (action.type === 'GET_TEST_SERIES_ANALYSIS_DATA') {
        return {
            status : status.SUCCESS,
            overAllPerformance: action.payload.overAllPerformance
        };
    }
    return state;
}